import { useState, useEffect, useRef } from 'react';
import ThemeSwitcher2 from './ThemeSwitcher2';

export default function Profile({ data }) {
  const [openProf, setOpenProf] = useState(false);
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenProf(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative z-50 ml-3" ref={dropdownRef}>
      {!data ? (
        // Loading State
        <div className="w-10 h-10 rounded-full bg-[#FBEFEF] dark:bg-[#2d1f1f] animate-pulse ring-1 ring-[#452829]/10 dark:ring-[#F5AFAF]/10"></div>
      ) : !data?.req ? (
        // Unauthorized (Login Button)
        <a
          href={`${process.env.REACT_APP_ACCOUNT_URL}/a/login?re=${process.env.REACT_APP_URL}`}
          className="group flex items-center gap-2 px-5 py-2 bg-[#452829] dark:bg-[#FBEFEF] text-[#FBEFEF] dark:text-[#452829] text-xs sm:text-sm font-bold rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#452829]/20 hover:-translate-y-0.5 active:translate-y-0 active:scale-95"
        >
          <img
            className="h-4 w-4 opacity-90 group-hover:scale-110 transition-transform"
            src="/logo/favicon-32x32.png"
            alt="logo"
          />
          <span>Login</span>
        </a>
      ) : (
        <>
          {/* Profile Trigger Button */}
          <button
            type="button"
            onClick={() => setOpenProf(!openProf)}
            className={`relative w-10 h-10 sm:w-11 sm:h-11 rounded-full p-0.5 transition-all duration-300 ${
              openProf 
                ? 'ring-2 ring-[#F5AFAF] scale-105 bg-[#F5AFAF]' 
                : 'ring-1 ring-[#452829]/10 dark:ring-[#F5AFAF]/20 hover:ring-[#452829]/30 bg-[#FBEFEF] dark:bg-[#2d1f1f]'
            }`}
          >
            <img
              className="w-full h-full rounded-full object-cover border border-[#FCF8F8] dark:border-[#452829]"
              src={data.user.profile_p}
              alt="profile"
            />
            {/* Status Dot */}
            <span className="absolute bottom-0 right-0 w-3 h-3 bg-[#F5AFAF] border-2 border-[#FCF8F8] dark:border-[#1a1111] rounded-full"></span>
          </button>

          {/* Premium Dropdown Menu */}
          {openProf && (
            <div className="absolute right-0 top-14 w-56 bg-[#FCF8F8] dark:bg-[#1a1111] border border-[#452829]/10 dark:border-[#F5AFAF]/10 rounded-xl shadow-[0_10px_40px_-10px_rgba(69,40,41,0.2)] dark:shadow-black/50 overflow-hidden origin-top-right animate-in fade-in zoom-in-95 duration-200">
              
              {/* Header Section */}
              <div className="px-4 py-3 bg-[#FBEFEF]/60 dark:bg-[#2d1f1f]/60 border-b border-[#452829]/5 dark:border-[#FBEFEF]/5 backdrop-blur-sm">
                {data.auth ? (
                  <>
                    <h2 className="text-sm font-bold text-[#452829] dark:text-[#F9DFDF] truncate">
                      {data.user.firstName} {data.user.lastName}
                    </h2>
                    <p className="text-[10px] font-medium text-[#452829]/50 dark:text-[#FBEFEF]/50 truncate mt-0.5 font-mono tracking-wide">
                      {data.user.email}
                    </p>
                  </>
                ) : (
                  <>
                    <h2 className="text-sm font-bold text-[#452829] dark:text-[#F9DFDF]">
                      {data.user.username || 'Guest'}
                    </h2>
                    <div className="mt-1 inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-[#F5AFAF]/20 text-[#452829] dark:text-[#F5AFAF] tracking-wider">
                      GUEST MODE
                    </div>
                  </>
                )}
              </div>
               

              {/* Menu Items */}
              {data?.auth ? (
                <div className="p-1 flex flex-col gap-1">
                  
                  {/* Account Settings */}
                  <a
                    href={`${process.env.REACT_APP_ACCOUNT_URL}/u`}
                    target='_blank'
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 px-2 py-2 rounded-xl text-xs font-bold text-[#452829]/80 dark:text-[#FBEFEF]/80 hover:bg-[#FBEFEF] dark:hover:bg-[#2d1f1f] hover:text-[#452829] dark:hover:text-[#FBEFEF] transition-all group"
                  >
                    <span className="w-8 h-8 rounded-lg bg-[#452829]/5 dark:bg-[#FBEFEF]/5 flex items-center justify-center group-hover:bg-[#452829] dark:group-hover:bg-[#FBEFEF] group-hover:text-[#FBEFEF] dark:group-hover:text-[#452829] transition-colors">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.1a2 2 0 0 1-1-1.74v-.47a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>
                    </span>
                    Settings
                  </a>

                  {/* Theme Switcher Wrapper */}
                  <div className="flex items-center gap-3 px-2 py-1 rounded-xl text-xs font-bold text-[#452829]/80 dark:text-[#FBEFEF]/80 hover:bg-[#FBEFEF] dark:hover:bg-[#2d1f1f] transition-all group cursor-pointer" onClick={(e) => e.stopPropagation()}>
                     <span className="w-8 h-8 rounded-lg bg-[#452829]/5 dark:bg-[#FBEFEF]/5 flex items-center justify-center group-hover:bg-[#452829] dark:group-hover:bg-[#FBEFEF] group-hover:text-[#FBEFEF] dark:group-hover:text-[#452829] transition-colors">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
                     </span>
                     <div className="flex-1 flex justify-between items-center">
                        <span>Theme</span>
                        <div className="scale-75 origin-right"><ThemeSwitcher2 /></div>
                     </div>
                  </div>

                  <div className="h-px bg-[#452829]/5 dark:bg-[#FBEFEF]/5 mx-2 my-0"></div>

                  {/* Logout */}
                  <a
                    href={`${process.env.REACT_APP_ACCOUNT_URL}/a/logout`}
                    className="flex items-center gap-3 px-2 py-2 rounded-xl text-xs font-bold text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all group"
                  >
                    <span className="w-8 h-8 rounded-lg bg-red-50 dark:bg-red-900/10 flex items-center justify-center group-hover:bg-red-500 group-hover:text-white transition-colors">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                    </span>
                    Log Out
                  </a>
                </div>
              ): (
                <div className="p-1 flex flex-col gap-1">
                  
                  {/* Account Settings */}
                 

                  {/* Theme Switcher Wrapper */}
                  <div className="flex items-center gap-3 px-2 py-1 rounded-xl text-xs font-bold text-[#452829]/80 dark:text-[#FBEFEF]/80 hover:bg-[#FBEFEF] dark:hover:bg-[#2d1f1f] transition-all group cursor-pointer" onClick={(e) => e.stopPropagation()}>
                     <span className="w-8 h-8 rounded-lg bg-[#452829]/5 dark:bg-[#FBEFEF]/5 flex items-center justify-center group-hover:bg-[#452829] dark:group-hover:bg-[#FBEFEF] group-hover:text-[#FBEFEF] dark:group-hover:text-[#452829] transition-colors">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>
                     </span>
                     <div className="flex-1 flex justify-between items-center">
                        <span>Theme</span>
                        <div className="scale-75 origin-right"><ThemeSwitcher2 /></div>
                     </div>
                  </div>


                  {/* Logout */}
                  
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}